import { __assign, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import { Selector } from '../selector/Selector';
import { fetchUserAccountsByEmail } from '../services/api';
import { withProviders } from '../selector/Selector.container';
import s from '../stories/styles/AccountSelector.scss';
var AccountSelectorComp = function (_a) {
    var email = _a.email, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, title = _a.title, subTitle = _a.subTitle, actionBtnText = _a.actionBtnText, userAccounts = _a.userAccounts, onLoaded = _a.onLoaded, onError = _a.onError, dataHook = _a.dataHook, locale = _a.locale, wsrProviderProps = _a.wsrProviderProps, props = __rest(_a, ["email", "isMobile", "title", "subTitle", "actionBtnText", "userAccounts", "onLoaded", "onError", "dataHook", "locale", "wsrProviderProps"]);
    var t = useTranslation().t;
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState({}), _e = _d[0], loggedInUser = _e.loggedInUser, accounts = _e.accounts, setUser = _d[1];
    useEffect(function () {
        if (!isLoading || (!email && !accounts)) {
            return;
        }
        var setData = function (data) {
            setUser({
                accounts: data.accountsData,
                loggedInUser: data.loggedInUserData,
            });
        };
        var fetchAccounts = function (e) {
            return userAccounts
                ? Promise.resolve(userAccounts)
                : fetchUserAccountsByEmail(e);
        };
        fetchAccounts(email)
            .then(function (data) {
            if (!data) {
                return onError === null || onError === void 0 ? void 0 : onError('an error occurred');
            }
            setData(data);
            onLoaded === null || onLoaded === void 0 ? void 0 : onLoaded((data === null || data === void 0 ? void 0 : data.accountsData) || [], data.loggedInUserData);
        })
            .catch(function (error) { return onError && onError(error); })
            .finally(function () { return setIsLoading(false); });
    }, [email]);
    var accountsData = accounts === null || accounts === void 0 ? void 0 : accounts.map(function (account) {
        var _a;
        return (__assign(__assign({}, account), { accountDisplayData: __assign(__assign({}, account.accountDisplayData), { description: t(account.parentAccountId
                    ? 'account_selector.item.organization_account_description'
                    : 'account_selector.item.wix_account_description', { name: (_a = account.accountDisplayData) === null || _a === void 0 ? void 0 : _a.name }) }) }));
    });
    return (React.createElement(Selector, __assign({ loggedInUserData: loggedInUser, userAccounts: accountsData, email: email, isLoading: isLoading, title: title !== null && title !== void 0 ? title : t('account_selector.default_title'), subTitle: React.createElement(SubTitle, { email: email, text: subTitle, isMobile: isMobile }), isMobile: isMobile, avatarShape: "circle" }, props)));
};
var SubTitle = function (_a) {
    var text = _a.text, email = _a.email, isMobile = _a.isMobile;
    if (React.isValidElement(text)) {
        return text;
    }
    return text ? (React.createElement(Text, { id: s["accountSelector_subtitile"], size: "small" }, text)) : (React.createElement(Text, { id: s["accountSelector_subtitile"], size: "small" },
        React.createElement(Trans, { i18nKey: "account_selector.default_sub_title", values: { email: email } },
            React.createElement("span", null, "These Wix accounts are also using"),
            isMobile && React.createElement("br", null),
            React.createElement("b", null, "email"),
            !isMobile && React.createElement("br", null),
            React.createElement("span", null, "Select the account you'd like to continue with."))));
};
export var AccountSelector = withProviders(AccountSelectorComp);
//# sourceMappingURL=AccountSelector.js.map